import React from 'react';
import { FooterHelp } from '@shopify/polaris';
import ceoImg from '../../../assets/images/CEO.png';

const MCPFooterHelp = (props) => {
  return (
    <FooterHelp>
      <div className="main-div">
        <img src={ceoImg} alt="Img" />
        <div>Need help? Contact your relation manager at <a rel="noreferrer noopener" aria-label=" (opens in a new tab)" href="mailto:support@mlveda.com" target="_blank"><span className="emailLink">support@mlveda.com</span></a></div>
      </div>
    </FooterHelp>
  )
}

export default MCPFooterHelp;